<template>
  <div class="signup-header-section">
    <h4 v-if="steps > 0" class="signup-header-section__steps">
      {{ $tc('SignupPage.Steps.label') }} {{ steps }}/3
    </h4>
    <h3 class="signup-header-section__title">{{ pageTitle }}</h3>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * 新規会員登録 ヘッダーセクション
 */
export default defineComponent({
  name: 'SignupHeaderSection',
  components: {},
  props: {
    /**
     * カレントステップ番号
     */
    steps: {
      type: Number,
      default: 0,
    },
    /**
     * ページタイトル
     */
    pageTitle: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.signup-header-section {
  background: $white;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 5%);

  &__steps {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding-top: 10px;
    @include fontSetTextMedium(12);

    font-weight: 700;
  }

  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    @include fontSetTextMedium();

    font-weight: 700;
  }
}
</style>
